module.exports = __webpack_public_path__ + "static/media/share.63a8cfc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/share.png
// module id = 182
// module chunks = 0